import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import {
  FORMATTED_VALUE_FALLBACK,
  formatTemperature,
} from '../utils/formatted-value-formatter.function';

@Pipe({
  name: 'formattedTemperature',
  standalone: true,
})
export class FormattedTemperaturePipe implements PipeTransform {
  private readonly locale = inject(LOCALE_ID);

  public transform(value: unknown, fallback = FORMATTED_VALUE_FALLBACK): string {
    return formatTemperature(value, this.locale, fallback);
  }
}
